import React from "react";
import Head from "next/head";

// HTML title component for pages.
const PageTitle = ({ title }) => {
  return (
    <Head>
      <title>{title}</title>
    </Head>
  );
};

export default PageTitle;
